export default __webpack_public_path__ + "static/media/visual_05.830659b2.png";